import { __extends } from "tslib";
import Manager from '../Abstracts/Manager';
import Managers from '../Constants/Managers';
import Application from '../../../Architecture/Core/Application';
var LanguageManager = /** @class */ (function (_super) {
    __extends(LanguageManager, _super);
    /* CONSTRUCTOR */
    function LanguageManager(language, acceptedLanguages) {
        var _this = _super.call(this) || this;
        _this.language = language;
        _this.acceptedLanguages = acceptedLanguages;
        return _this;
    }
    /* METHODS */
    LanguageManager.prototype.setLanguage = function (language) {
        if (this.language != language && !this.isBusy) {
            this.isBusy = true;
            this.language = language;
            this.changeLanguage();
        }
    };
    LanguageManager.prototype.checkLanguage = function () {
        var path = Application.current.resolve(Managers.NAVIGATION_MANAGER).route;
        if (path.split("/").length > 2) {
            if (this.acceptedLanguages.find(function (language) { return language == path.split("/")[1]; }) != undefined) {
                this.setLanguage(path.split("/")[1]);
            }
            else {
                this.setLanguage(this.language);
            }
        }
        else {
            this.setLanguage(this.language);
        }
    };
    LanguageManager.prototype.changeLanguage = function () {
        Application.current.resolve(Managers.NAVIGATION_MANAGER)
            .navigate(Application.current.resolve(Managers.NAVIGATION_MANAGER).route.substring(6));
        this.isBusy = false;
    };
    return LanguageManager;
}(Manager));
export default LanguageManager;
